import axios from "axios";
import AuthAPI from "./login/authApi";

export default {
    namespaced: true,
    state: {
        // `authToken` for routing block
        authToken: localStorage.getItem("access-token") || "",
        status: ""
    },  
    mutations: {
        ["AUTH_REQUEST"](state) {
            state.status = "loading";
        },
        ["AUTH_SUCCESS"](state, token) {
            // console.log(state, token);
            state.status = "success";
            state.authToken = token;
        },
        ["AUTH_ERROR"](state) {
            state.status = "error";
        },
        ["AUTH_LOGOUT"](state) {
            state.authToken = "";
        }
    },
    getters: {
        // `isAuthenticated` for routing block
        isAuthenticated(state) {            
            return !!state.authToken;
        },
        authStatus(state) {
            return state.status;
        }
    },
    actions: {
        authRequest({ commit, dispatch }, formData) {
            return new Promise((resolve, reject) => {
                console.log("AUTH REQUEST");
                // The Promise used for router redirect in login
                commit("AUTH_REQUEST");
                AuthAPI.requireToken(formData)
                    .then(res => {
                        // console.log(res);
                        dispatch("setTokens", res);
                        commit("AUTH_SUCCESS", res.data.token);
                        // you have your token, now log in your user :)
                        // dispatch("USER_REQUEST")
                        resolve(res);
                    })
                    .catch(err => {
                        commit("AUTH_ERROR", err);
                        dispatch("removeTokens");
                        reject(err);
                    });
            });
        },     
        authLogout: ({ commit, dispatch }) => {
            return new Promise((resolve, reject) => {
                commit("AUTH_LOGOUT");
                dispatch("removeTokens");                
                resolve();
            });
        },
        // helper actions (called from this actions)
        setTokens({ dispatch }, res) {
            console.log(res);
            const token = res.data.token;
            const refreshToken = res.data.refresh_token;
            localStorage.setItem("access-token", token); // store the token in localstorage
            localStorage.setItem("refresh-token", refreshToken); // store the refresh token in localstorage
            // set axios default headers
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        },
        removeTokens() {
            localStorage.removeItem("access-token"); // if the request fails, remove any possible user token if possible
            localStorage.removeItem("refresh-token");
            // remove axios default headers
            delete axios.defaults.headers.common["Authorization"];
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js